import { ErrorDetails } from './error-details';

export class ErrorData {
  constructor(public code: string, public message: string, public details: ErrorDetails[]) {}
}
